module.exports = __webpack_public_path__ + "img/auth.9f90d1e8.png";